<template>
  <div id="app" v-if="isLoad" style="">
    <!-- <Header windows="main"></Header> -->
    <container v-if="!$route.meta.allScreen">
      <keep-alive>
        <router-view v-if="$route.meta.auth" />
      </keep-alive>
      <router-view v-if="!$route.meta.auth" />
    </container>
    <router-view v-else />
  </div>
</template>

<script>
import container from "@/components/container";
import { mapState } from "vuex";
// electron 项目打开
// import Header from '@/components/electron/Header.vue';
export default {
  components: {
    container,
    // electron 项目打开
    // Header
  },
  data() {
    return {
      isShow: true,
      isLoad: true,
    };
  },
  computed: {
    ...mapState("user", ["info"]),
  },
  async mounted() {
    // if (this.info.type == 1) {
    //   this.$router.push("/master");
    // } else if (this.info.type == 2) {
    //   this.$router.push("/production3");
    // } else {
    //   this.$router.push("/");
    // }
  },
};
</script>

<style lang="less">
@import url("./assets/css/component.css");

// 引入字体文件
@font-face {
  font-family: "繁体";
  src: url("@/assets/font/繁体.ttf")
}


* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html,
body {
  width: 100%;
  height: 100%;
  font-size: 12px;
  font-family: '繁体';
}

#app {
  width: 100%;
  height: 100%;
}

.el-message {
  z-index: 999999 !important;
}

.el-table__fixed-body-wrapper tr:not(.el-table__row):not(.el-table__row--striped) {
  /* 你的样式 */
  visibility: hidden;
}


// .el-select-dropdown__item{
// 	// display: flex;
// 	// flex-direction: column;
// 	// height: auto !important;
// }
//设置打印时表格样式，防止打印位置不准确
@media print {
  .el-main {
    top: 0px !important;
    transform: translateX(-30px) !important;
  }
  .is-scrolling-none {
    overflow: hidden !important;
  }
}

  ::-webkit-scrollbar {
	width: 6px;
	height: 8px;
	background-color: #ebeef5;
}
// 滚动条样式
::-webkit-scrollbar-thumb {
	box-shadow: inset 0 0 6px rgba(0, 0, 0, .3);
	-webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .3);
	background-color: #ccc;
}
// 滚动条样式
::-webkit-scrollbar-track{
	box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
	border-radius: 3px;
	background: rgba(255, 255, 255, 1);
}

a {
  text-decoration: none;
}
</style>
